import React from "react";
import MerdeIcon from "./../MerdeIcon";

/**
 * Brukes der vi tidligere forventet et "status-ikon"
 * (tabeller, cards, badges osv.)
 *
 * @param {string} status  AG / MG / AY / MY / AR / MR
 * @param {number} size    ikonstørrelse (default 20)
 */
export const StatusIcon = ({ status, size = 20 }) => {
  return <MerdeIcon status={status} size={size} />;
};
